import axios from 'axios'

// config
import baseUrl from '../config'

export const fetchAttendanceProofs = async params => {
  const response = await axios.get(`${baseUrl}/sef/attendance-proofs`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchParticipantAttendance = async participantId => {
  const response = await axios.get(`${baseUrl}/sef/participant-attendances/${participantId}`, {
    withCredentials: true
  })

  return response.data
}

export const fetchParticipantAttendances = async params => {
  const response = await axios.get(`${baseUrl}/sef/participant-attendances`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const createParticipantAttendance = async data => {
  return await axios({
    withCredentials: true,
    method: 'POST',
    url: `${baseUrl}/sef/participant-attendances`,
    data
  })
}

export const updateParticipantAttendance = async ({ attendanceLogId, data }) => {
  return await axios({
    withCredentials: true,
    method: 'PATCH',
    url: `${baseUrl}/sef/participant-attendances/${attendanceLogId}`,
    data
  })
}

export const importParticipantAttendances = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/import-biosyntrix-participant-attendances`,
    data
  })
}

export const importAttendancesProof = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/import-attendances-proof`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const createAttendanceProofReview = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/attendance-proofs-reviews`,
    data
  })
}
